import { createApi } from "@reduxjs/toolkit/query/react";
import axiosBaseQuery from "./axiosBaseQuery/axiosBaseQuery";
import config from "../../config/config";

// Define a service using a base URL and expected endpoints
export const hatvNotesAPI = createApi({
  reducerPath: "hatvNotesAPI",
  baseQuery: axiosBaseQuery({
    baseUrl: config.appUrl,
  }),
  keepUnusedDataFor: 900,
  tagTypes: ["hatvQNotes"],
  endpoints: (builder) => ({
    getHatvNotesList: builder.query<any, GoalsAndActionPlansArgTypes>({
      query: ({ affiliateCode, aboNumber, year, type }) => ({
        url: `/am/abo/${affiliateCode}/${aboNumber}/notes/year/${year}/type/${type}`,
        method: "GET",
      }),
      providesTags: (result, error, args) => [
        { type: "hatvQNotes", id: args.type?.toUpperCase() },
      ],
    }),

    getHatvAwardNotesList: builder.query<any, HATVAwardNotesArgTypes>({
      query: ({
        affiliateCode,
        aboNumber,
        year,
        awardCode,
        type,
        qualifiedMonth,
      }) => ({
        url: `/am/abo/${affiliateCode}/${aboNumber}/notes/year/${year}/award/${awardCode}/qualifiedmonth/${qualifiedMonth}/type/${type}`,
        method: "GET",
      }),
      providesTags: (result, error, args) => [
        { type: "hatvQNotes", id: args.type?.toUpperCase() },
      ],
    }),

    createHatvNotes: builder.mutation<any, createNotesArgTypes>({
      query: ({ affiliateCode, aboNumber, payload, type }) => ({
        url: `/am/abo/${affiliateCode}/${aboNumber}/note/create/type/${type}`,
        method: "POST",
        data: payload,
      }),

      invalidatesTags: (result, error, args) => [
        { type: "hatvQNotes", id: args.type?.toUpperCase() },
      ],
    }),

    editHatvNotes: builder.mutation<any, editeNotesArgTypes>({
      query: ({ affiliateCode, aboNumber, payload, type }) => ({
        url: `/am/abo/${affiliateCode}/${aboNumber}/note/update/type/${type}`,
        method: "POST",
        data: payload,
      }),
      invalidatesTags: (result, error, args) => [
        { type: "hatvQNotes", id: args.type?.toUpperCase() },
      ],
    }),

    deleteHatvNotes: builder.mutation<any, deleteNotesArgTypes>({
      query: ({ id }) => ({
        url: `/am/abo/note/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: (result, error, args) => [
        { type: "hatvQNotes", id: args.type?.toUpperCase() },
      ],
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetHatvNotesListQuery,
  useGetHatvAwardNotesListQuery,
  useCreateHatvNotesMutation,
  useEditHatvNotesMutation,
  useDeleteHatvNotesMutation,
} = hatvNotesAPI;
